<span [innerHTML]="generateAvatar() | safeHtml"></span>
